import { Check } from "lucide-react";
import { VISUAL_STYLES } from "../../lib/visualStyles";

export default function StylePicker({ value, onChange, disabled, testid = "style-picker" }) {
  return (
    <div className="grid grid-cols-4 gap-2" data-testid={testid}>
      {VISUAL_STYLES.map((s) => {
        const active = value === s.v;
        return (
          <button
            key={s.v}
            type="button"
            disabled={disabled}
            onClick={() => onChange(s.v)}
            data-testid={`style-opt-${s.v}`}
            className={`group relative rounded-md overflow-hidden border transition-all disabled:opacity-50 ${active ? "border-blue-500 ring-2 ring-blue-500/40" : "border-white/10 hover:border-white/30"}`}
          >
            <img src={s.thumb} alt={s.l} loading="lazy" className="w-full aspect-video object-cover" />
            {active && (
              <span className="absolute top-1 right-1 h-4 w-4 rounded-full bg-blue-500 grid place-items-center">
                <Check className="h-3 w-3 text-white" />
              </span>
            )}
            <span className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/85 to-transparent px-1.5 pt-3 pb-1 text-[10px] font-medium text-white text-left leading-tight">
              {s.l}
            </span>
          </button>
        );
      })}
    </div>
  );
}
